export function BrandMark({ large = false, label }: { large?: boolean; label?: string }) {
  return (
    <span className={`brand-mark ${large ? "large" : ""}`} role={label ? "img" : undefined} aria-label={label} aria-hidden={label ? undefined : true}>
      <svg viewBox="0 0 48 48" focusable="false">
        <rect x="4" y="4" width="40" height="40" rx="11" className="mark-tile" />
        <path d="M11 14h7.5c6 0 6.5 10 14.5 10h3" className="mark-chain mark-chain-top" />
        <path d="M11 34h7.5c6 0 6.5-8 14.5-8h3" className="mark-chain mark-chain-bottom" />
        <path d="m33.5 17.5 9 7-9 7Z" className="mark-forward" />
      </svg>
    </span>
  );
}
